import { SweepButton } from "@softmax/design-system";
import type { ProfileEditorProps } from "../use-profile-settings";
import { sectionLabel, checkboxStyle } from "./profile-styles";
import { ProfileStatus } from "./profile-status";

const preferences = [
  {
    key: "consentServiceUpdates",
    title: "Service updates",
    description: "Email me about important product and service updates.",
  },
  {
    key: "consentMarketing",
    title: "Announcements",
    description: "Email me about launches, events, and announcements.",
  },
] as const;

export function ProfilePreferences({ editor }: ProfileEditorProps) {
  const { profile, writes } = editor;
  return (
    <section
      aria-labelledby="account-communication"
      className="flex flex-1 flex-col gap-[24px] pt-[24px]"
    >
      <h2 id="account-communication" className={sectionLabel}>
        Communication preferences
      </h2>
      <div className="flex flex-col gap-[16px]">
        {preferences.map(({ key, title, description }) => (
          <div key={key} className="flex flex-col gap-[4px]">
            <div className="flex flex-wrap items-center gap-x-[12px] gap-y-[4px]">
              <label className="flex items-center gap-[12px]">
                <input
                  type="checkbox"
                  name={key}
                  className={checkboxStyle}
                  checked={profile.preferences[key]}
                  disabled={writes.locked}
                  aria-disabled={writes.locked || undefined}
                  onChange={(event) =>
                    profile.savePreference({ key, value: event.target.checked })
                  }
                />
                <span className="font-plex-sans text-[16px] leading-[24px] text-[#161616]">
                  {title}
                </span>
              </label>
              <ProfileStatus notice={writes.notices[key] ?? null} />
              {profile.draft[key] !== undefined && !writes.locked ? (
                <SweepButton
                  quiet
                  type="button"
                  focus="ring"
                  onClick={() =>
                    profile.savePreference({
                      key,
                      value: profile.preferences[key],
                    })
                  }
                >
                  Retry save
                </SweepButton>
              ) : null}
            </div>
            <p className="font-plex-sans pl-[28px] text-[12px] leading-[15.6px] text-[#7c7c7c]">
              {description}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
